import {useRef} from "react";

/**
 * Custom hook to handle audio element with stop function
 * @returns {{ref: React.MutableRefObject<null>, stop: stop}}
 */
export function useAudioElement() {

  const audioRef = useRef(null);

  const stop = () => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }

  return {ref: audioRef, stop};

}